import workspaceQuery from '../../../graphql/queries/sales/ConnectTransactionWorkspaceQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ConnectTransaction: EntityType = {
  type: 'ConnectTransaction',
  title: 'Connect PAC Transactions',
  workspaceUrl: '/Sales/ConnectTransaction/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'SALES_CONNECT_TRANSACTIONS',
};

export default ConnectTransaction;
